import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetAppConfigs,
  GetAppDefinations,
} from '../../../redux/app/api-calls/configCalls';

import { Col, ListGroup, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBullhorn,
  faChevronRight,
  faBell,
} from '@fortawesome/free-solid-svg-icons';

import { Copyright } from '../../../common/clientConfig';
import {
  FacebookSVG,
  TwitterSVG,
  LinkedinSVG,
  YoutubeSVG,
} from '../../img/FooterSVG';
import Skeleton from './Skeleton';

library.add(faBullhorn, faChevronRight, faBell);

export default () => {
  const { isMediaLinksLoaded, mediaLinksInfo } = useSelector(
    (state) => state.footer,
  );
  const { branding } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const mediaLinks = Object.values(mediaLinksInfo);
  const [displayStayConnected, setdisplayStayConnected] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => dispatch(GetAppDefinations()), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setdisplayStayConnected(false);

    if (mediaLinks) {
      if (
        mediaLinksInfo?.Facebook?.URL == '' &&
        mediaLinksInfo?.Twitter?.URL == '' &&
        mediaLinksInfo?.YouTube?.URL == '' &&
        mediaLinksInfo?.LinkedIn?.URL == ''
      ) {
        setdisplayStayConnected(true);
      }
    }
  }, [mediaLinks]);

  return (
    <div className="common-footer">
      <div className="container-fluid container-offset mt-5">
        <Row>
          <Col md={6} lg={6} sm={6} xs={6}>
            <Row>
              <Col>
                {!isMediaLinksLoaded && <Skeleton count={5} />}
                {isMediaLinksLoaded &&
                Object.keys(mediaLinksInfo)?.length > 0 &&
                !displayStayConnected ? (
                  <>
                    <h3>Connect with us</h3>
                    <ListGroup horizontal className="social-icons">
                      {mediaLinksInfo?.Facebook?.URL && (
                        <>
                          <ListGroup.Item>
                            <a
                              href={mediaLinksInfo?.Facebook?.URL}
                              target="_blank"
                              alt="facebook"
                              title="Facebook"
                              rel="noreferrer"
                            >
                              <FacebookSVG />
                            </a>
                          </ListGroup.Item>
                        </>
                      )}
                      {mediaLinksInfo?.Twitter?.URL && (
                        <>
                          <ListGroup.Item>
                            <a
                              href={mediaLinksInfo?.Twitter?.URL}
                              target="_blank"
                              alt="Twitter"
                              title="Twitter"
                              rel="noreferrer"
                            >
                              {/*<i className="fab fa-twitter"></i> */}
                              <TwitterSVG />
                            </a>
                          </ListGroup.Item>
                        </>
                      )}
                      {mediaLinksInfo?.YouTube?.URL && (
                        <>
                          <ListGroup.Item>
                            <a
                              href={mediaLinksInfo?.YouTube?.URL}
                              target="_blank"
                              alt="YouTube"
                              title="YouTube"
                              rel="noreferrer"
                            >
                              {/*<i className="fab fa-youtube"></i> */}
                              <YoutubeSVG />
                            </a>
                          </ListGroup.Item>
                        </>
                      )}
                      {mediaLinksInfo?.LinkedIn?.URL && (
                        <>
                          <ListGroup.Item>
                            <a
                              href={mediaLinksInfo?.LinkedIn?.URL}
                              target="_blank"
                              alt="LinkedIn"
                              title="LinkedIn"
                              rel="noreferrer"
                            >
                              {/*<i className="fab fa-linkedin-square"></i> */}
                              <LinkedinSVG />
                            </a>
                          </ListGroup.Item>
                        </>
                      )}
                    </ListGroup>
                  </>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>

        <p className="copy-right">{branding?.Copyright}</p>
      </div>
    </div>
  );
};
